import { Component, h, Prop, Host } from "@stencil/core";
import { CallStatusType } from "../service-calls-response";

/**
 * @deprecated Use `ux-w-status` instead.
 * @slot - Content of the status.
 */
@Component({
    tag: "ux-w-service-calls-status",
    styleUrl: "service-calls-status.scss",
    shadow: false
})
export class ServiceCallsStatus {
    /** type of the status */
    @Prop({ reflect: true }) type: CallStatusType;
    /**
     * amount of messages to display
     * @deprecated status with messages should be handled on the server side
     **/
    @Prop() messageCount?: number | null;

    render() {
        let type: CallStatusType = this.type;

        if (this.messageCount && this.messageCount > 0) {
            type = CallStatusType.NEW_MESSAGE;
        }

        return (
            <Host class="ux-w-service-calls-status">
                <ux-w-status type={`SERVICE_CALL_${type}`}>
                    <slot />
                </ux-w-status>
            </Host>
        );
    }
}
